module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("cPGdd"))).then(() => module.bundle.root('ikE14'));